import { gql } from '@apollo/client';
/**
 * @const CancelDealSignatureMutation
 * @since 1.0.0
 */
export const CancelDealSignatureMutation = gql `
  mutation CancelDealSignatureMutation($input: CancelDealSignatureInput!) {
    cancelDealSignature(input: $input)
  }
`;
